export default {
  destinations: {
    bellwald: 'bellwald',
    niesen: 'niesen',
    vals: 'vals',
    chaeserrugg: 'chaeserrugg',
    moosalpregion: 'moosalpregion',
    default: 'default',
  },
  datePicker: {
    // default range for the range date picker
    dateRangeDays: 7,
  },
  priceFactors: {
    value: 'value',
    demand: 'demand',
    weekday: 'weekday',
    seasonality: 'seasonality',
  },
  globalChartSettings: {
    pointRadius: 2,
    // line width
    borderWidth: 2,
    maxBarThickness: 30,
    yAxisWidth: 70,
  },
  colors: {
    dipolar: ['#1B3E5E', '#DC1E46'],

    lineChart: [
      '#27852D',
      '#E8A900',
      '#89285D',
      '#DC1E46',
      '#2699D6',
      '#1B3E5E',
    ],

    named: {
      totalPrice: '#1B3E5E',
      minPrice: '#2699D6',
      weekday: '#C9E5F5',
      seasonality: '#89285D',
      seasonalityBackground: '#F3EAEF',
      demand: '#93CCEB',
      value: '#ED8FA2',
      overwritten: '#DC1E46',
      red: '#DA254B',
    },
  },
  permissions: {
    pricingDashboardWorld: ['FRONTEND_ACCESS_PE'],
    shopAdminWorld: ['FRONTEND_ACCESS_SHOP', 'FRONTEND_ACESS_AXESS_SETTINGS'],
    engine: {
      PE_GET_EXPECTED_DEMAND: 'PE_GET_EXPECTED_DEMAND',
      PE_GET_PRICES: 'PE_GET_PRICES',
      PE_GET_VALDEM: 'PE_GET_VALDEM',
      PE_GET_SALES: 'PE_GET_SALES',
      PE_GET_WEATHERS: 'PE_GET_WEATHERS',
      PE_PUT_WEATHERS: 'PE_PUT_WEATHERS',
      PE_GET_SEASON_PHASES: 'PE_GET_SEASON_PHASES',
      PE_POST_SEASON_PHASES: 'PE_POST_SEASON_PHASES',
      PE_PUT_SEASON_PHASES: 'PE_PUT_SEASON_PHASES',
      PE_GET_SUPP_SEASONALITIES: 'PE_GET_SUPP_SEASONALITIES',
      PE_PUT_SUPP_SEASONALITIES: 'PE_PUT_SUPP_SEASONALITIES',
      PE_GET_WEAKDAYS: 'PE_GET_WEAKDAYS',
      PE_POST_IMPORTS: 'PE_POST_IMPORTS',
      PE_PUT_PRICES: 'PE_PUT_PRICES',
    },
    shopApi: {
      BOOKING_AUDIT_CANCELLATIONS: 'BOOKING_AUDIT_CANCELLATIONS',
      BOOKING_CANCEL_BOOKINGS: 'BOOKING_CANCEL_BOOKINGS',
      BOOKING_SEARCH_ALL_BOOKINGS: 'BOOKING_SEARCH_ALL_BOOKINGS',
      BOOKING_SITES_ADMIN: 'BOOKING_SITES_ADMIN',
      BOOKING_CRUD_PRODUCT_CAPACITY: 'BOOKING_CRUD_PRODUCT_CAPACITY',
      BOOKING_CRUD_EVENTS: 'BOOKING_CRUD_EVENTS',
      BOOKING_CRUD_TRANSLATIONS: 'BOOKING_CRUD_TRANSLATIONS',
      BOOKING_CRUD_EXTENDED_ATTRIBUTES: 'BOOKING_CRUD_EXTENDED_ATTRIBUTES',
      BOOKING_CRUD_BOOKINGS: 'BOOKING_CRUD_BOOKINGS',
      BOOKING_ADMIN_CHECKOUT: 'BOOKING_ADMIN_CHECKOUT',
      BOOKING_CRUD_USER_ROLE_LINK: 'BOOKING_CRUD_USER_ROLE_LINK',
      BOOKING_EXPORT_ACCOUNTING: 'BOOKING_EXPORT_ACCOUNTING', // accounting excel exports
      EDIT_REGION: 'EDIT_REGION',
      EDIT_EXTERNAL_URL: 'EDIT_EXTERNAL_URL',
    },
    frontend: {
      FRONTEND_ACCESS_PE_OVERVIEW: 'FRONTEND_ACCESS_PE_OVERVIEW',
      FRONTEND_ACCESS_PE_DETAILS: 'FRONTEND_ACCESS_PE_DETAILS',
      FRONTEND_ACCESS_PE_ANALYTICS: 'FRONTEND_ACCESS_PE_ANALYTICS',
      FRONTEND_ACCESS_PE_WEATHER: 'FRONTEND_ACCESS_PE_WEATHER',
      FRONTEND_ACCESS_PE_SETTINGS: 'FRONTEND_ACCESS_PE_SETTINGS',
      FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW:
        'FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW',
      FRONTEND_ACCESS_SHOP_BOOKING_EXTRARIDE:
        'FRONTEND_ACCESS_SHOP_BOOKING_EXTRARIDE',
      FRONTEND_ACCESS_SHOP_STORNO_HISTORY:
        'FRONTEND_ACCESS_SHOP_STORNO_HISTORY',
      FRONTEND_ACCESS_SHOP_REMARK_MANAGEMENT:
        'FRONTEND_ACCESS_SHOP_REMARK_MANAGEMENT', // display remarks on the booking overview
      FRONTEND_ACCESS_SHOP_CASH_DESK: 'FRONTEND_ACCESS_SHOP_CASH_DESK', // display buttons "Betrag erhalten" & "Tickets" drucken on booking overview. More to come!
      FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW_COMPLETE:
        'FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW_COMPLETE', // tabs on the booking overview
      FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW_AGGREGATED:
        'FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW_COMPLETE', // tabs on the booking overview
      FRONTEND_ACCESS_SHOP_PRICE_TABLE: 'FRONTEND_ACCESS_SHOP_PRICE_TABLE', // pricing table for the clients
      FRONTEND_ACCESS_SHOP_PRODUCTS: 'FRONTEND_ACCESS_SHOP_PRODUCTS', // edit products and capacities
      FRONTEND_ACCESS_SHOP_MANAGE_CAPACITY_LEVEL:
        'FRONTEND_ACCESS_SHOP_MANAGE_CAPACITY_LEVEL', // whether an user can define, on which level capacities take place in products
      FRONTEND_ACCESS_SHOP_EDIT_PRODUCT_ASSETS:
        'FRONTEND_ACCESS_SHOP_EDIT_PRODUCT_ASSETS', // whether an user can change product pictures or product titles
      FRONTEND_ACCESS_SHOP_REPORTS: 'FRONTEND_ACCESS_SHOP_REPORTS', // show reports
      FRONTEND_ACCESS_SHOP_EDIT_PRODUCT_AVAILABILITY:
        'FRONTEND_ACCESS_SHOP_EDIT_PRODUCT_AVAILABILITY', // whether an user can change update product availability
      FRONTEND_ACCESS_SHOP_SETTINGS: 'FRONTEND_ACCESS_SHOP_SETTINGS', // show my
      FRONTEND_ACCESS_PE_EDIT_PRICES_RULE_BASED:
        'FRONTEND_ACCESS_PE_EDIT_PRICES_RULE_BASED',
      FRONTEND_ACESS_AXESS_SETTINGS: 'FRONTEND_ACESS_AXESS_SETTINGS', // admin user can for example init a new season in the axess system.
    },
  },
  attributeKeys: {
    duration: 'duration',
    age: 'age',
    flex: 'flex',
    performanceDiff: 'performanceDiff',
    route: 'route',
    from: 'from',
    to: 'to',
    swisspass: 'swisspass',
    time: 'time',
    room: 'room',
    adults: 'adults',
    children: 'children',
    train: 'train',
    personAmount: 'personAmount',
    trainAdults: 'trainAdults',
    trainChildren: 'trainChildren',
    meal: 'meal',
    voucherType: 'voucherType',
    tarif: 'tarif',
  },
  attributeValues: {
    value: 'value',
    translation: 'translation',
    sortOrder: 'sortOrder',
    minAge: 'minAge',
    maxAge: 'maxAge',
    minYear: 'minYear',
    maxYear: 'maxYear',
    latestBookingTime: 'latestBookingTime',
    peopleCount: 'peopleCount',
  },
  attributeValueContent: {
    basic: 'basic',
    flex: 'flex',
    withHalfFareOrGA: 'withHalfFareOrGA',
    withHalfFareOrGANoValidation: 'withHalfFareOrGANoValidation',
    swissTravelPassNoValidation: 'swissTravelPassNoValidation',
    withGA: 'withGA',
    withHalfFare: 'withHalfFare',
    hiking: 'hiking',
    adults2: 'adults2',
    children0: 'children0',
    withTrain: 'withTrain',
    adult: 'adult',
    noReduction: 'noReduction',
    noSwisspass: 'noSwisspass',
    local: 'local',
    guestCard: 'guestCard',
  },
  // available ticket media
  ticketMedia: {
    paper: 'paper',
    swisspass: 'swisspass',
    skidata: 'skidata',
    axess: 'axess',
    reservation: 'reservation',
    printAtHome: 'paper-direct',
    pickUp: 'paper-pickup',
  },
}
